import { numberMoney } from 'Data/format.js'
import { getAdjustedTreatmentFeeBeforeInsurances } from 'Data/payment-plan.js'

export function getValue(payment_plan) {
  return numberMoney(getAdjustedTreatmentFeeBeforeInsurances(payment_plan))
}
